<aio-notification-menu
  #notificationMenu
  [unreadCount]="notificationsPoll.effectiveGlobalUnreadCount()"
  [statusLabel]="statusLabel()"
  [groups]="menuGroups()"
  [loading]="isLoading()"
  (opened)="onNotificationPopoverShow()"
  (closed)="onNotificationPopoverHide()"
  (itemPressed)="onItemPressed($event)">
  <ng-template aioNotificationItem let-item>
    <div class="user-avatar" [style.background-color]="generateAvatarColor(item.notification.createdByUserName)">
      @if (item.notification.createdByUserProfilePictureUrl) {
        <img [src]="item.notification.createdByUserProfilePictureUrl" [alt]="item.notification.createdByUserName" class="avatar-image" />
      } @else {
        <span class="avatar-initials">{{ generateInitials(item.notification.createdByUserName) }}</span>
      }
    </div>
    <div
      class="notification-message"
      [innerHTML]="item.notification.sanitizedMessage || item.notification.title">
    </div>
    <span class="notification-time">{{ item.notification.timestamp }}</span>
  </ng-template>
  @if (hasNextPage()) {
    <div aioNotificationFooter class="notification-list-footer">
      <aio-button appearance="neutral-stroke" size="sm" [loading]="isLoadingPaginated()" (pressed)="getNotificationsPaginated()">See More</aio-button>
    </div>
  }
</aio-notification-menu>
